export const removeTrailingSlash = (path: string) => {
  if (path.endsWith("/")) {
    return path.slice(0, -1);
  } else {
    return path;
  }
};

export const removeStartingSlash = (path: string) => {
  if (path.startsWith("/")) {
    return path.replace(/^(\/+)/gi, "");
  } else {
    return path;
  }
};

export const removeSurroundingSlashes = (path: string) => {
  return removeStartingSlash(removeTrailingSlash(path));
};

export const getUrlFromString = (value: string) => {
  try {
    return value.includes("brex.")
      ? new URL(value)
      : new URL("https://www.brex.com/" + value);
  } catch {
    return undefined;
  }
};
